import type { ComponentDocMap } from './types'

/**
 * Prop documentation for the `default_component` anchor component.
 * Keep in sync with DefaultComponentProps in src/ui/uiConfig/anchorComponents/DefaultComponent/DefaultComponent.types.ts
 */
export const defaultComponentPropDocs: ComponentDocMap = {
  tabs: {
    description: 'Top-level tabs containing cards and child UI config references.',
    type: 'DefaultComponentTab[]',
  },
  'tabs[].title': {
    description: 'Tab title.',
    type: 'string',
  },
  'tabs[].cards': {
    description: 'Cards rendered inside the tab.',
    type: 'DefaultComponentCard[]',
  },
  'tabs[].cards[].tourId': {
    description: 'Optional guided-tour identifier.',
    type: 'string',
  },
  'tabs[].cards[].title': {
    description: 'Card title.',
    type: 'string',
  },
  'tabs[].cards[].default_collapsed': {
    description: 'Initial collapsed state for card.',
    type: 'boolean',
  },
  'tabs[].cards[].remember_collapsed': {
    description: 'Persists collapsed state in local storage.',
    type: 'boolean',
  },
  'tabs[].cards[].children_list': {
    description: 'Child UI config references rendered inside the card.',
    type: 'DefaultComponentChild[]',
  },
  'tabs[].cards[].children_list[].ui_config_id': {
    description: 'Referenced child UI config id.',
    type: 'number',
  },
  'tabs[].cards[].children_list[].override_alias': {
    description: 'Alias overrides for this child only.',
    type: 'UiConfigAliases',
  },
  'tabs[].cards[].children_list[].override_props': {
    description: 'Prop overrides for this child only.',
    type: 'UiConfigProps',
  },
  overrideAlias: {
    description: 'Root-level alias overrides passed to descendants.',
    type: 'UiConfigAliases',
  },
}
